import { UnitType } from '@exodus/currency'

const name = 'eosio'
const displayName = 'EOS'
const ticker = 'EOS'
const displayTicker = 'EOS'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#7CADE2'
const gradientColors = ['#7CADE2', '#5F5A86']
const gradientCoords = { x1: '22.351%', y1: '-12.223%', x2: '98.837%', y2: '152.777%' }
const chainBadgeColors = gradientColors

const units = {
  larimer: 0,
  EOS: 4,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://eosflare.io/account/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://eosflare.io/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'EOS is an architecture to enable large-scale applications. EOS provides developers with accounts, authentication, databases, asynchronous communication and scheduling of applications across the protocol.',
  reddit: 'https://www.reddit.com/r/eos/',
  twitter: 'https://twitter.com/EosNFoundation',
  website: 'https://eosnetwork.com/',
  discord: 'https://discord.com/invite/eos-network',
  telegram: 'https://t.me/EOSNetworkFoundation',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
